import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-061a7faa"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "theme-pick-item" }

import {CheckOutlined} from "@ant-design/icons-vue";
import {IThemeImagePreview} from "@/app/editor/types";
import ImagePreview from "@/app/editor/views/ImagePreview.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'ImagePickItem',
  props: {
    image: {},
    isPick: { type: Boolean },
    width: {},
    height: {}
  },
  setup(__props: any) {




return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.image)
      ? (_openBlock(), _createBlock(ImagePreview, {
          key: 0,
          image: _ctx.image,
          width: _ctx.width,
          height: _ctx.height,
          radius: ""
        }, null, 8, ["image", "width", "height"]))
      : _createCommentVNode("", true),
    (_ctx.isPick)
      ? (_openBlock(), _createBlock(_unref(CheckOutlined), { key: 1 }))
      : _createCommentVNode("", true)
  ]))
}
}

})